'use strict';
const config = {
  API_VERSION: 'v3',
  API_PATH: 'app/api',
  AWS_URL: 'https://d3rk1qb6qh6l8b.cloudfront.net',
  CITIES: {
    BCN: {
      country: 'ES',
      code: 'BCN',
      wspCity: 'CITY__BCN',
      name: 'Barcelona',
      alias: 'Barcelona',
      lat: '41.39479',
      lon: '2.1587679',
      web: 'https://barcelona.wesmartpark.com',
      defaultLanguage: {
        lang: 'ca',
        langWsp: 'ca_ES',
        langIso: 'ca-ES',
        name: 'Català',
      },
      zoom: 14,
      googleAnalyticsAppId: '1:202996681746:web:e6766a5ae65444eeb2dccb',
      googleAnalyticsMeasurementId: 'G-B0370PX5PN',
    },
    MAD: {
      country: 'ES',
      code: 'MAD',
      wspCity: 'CITY__MAD',
      name: 'Madrid',
      alias: 'Madrid',
      lat: '40.441000',
      lon: '-3.686890',
      web: 'https://madrid.wesmartpark.com',
      defaultLanguage: {
        lang: 'es',
        langWsp: 'es_ES',
        langIso: 'es-ES',
        name: 'Castellano',
      },
      zoom: 14,
      googleAnalyticsAppId: '1:202996681746:web:757dfa9298d9df84b2dccb',
      googleAnalyticsMeasurementId: 'G-CR2C6ZNWJX',
    },
    LLE: {
      country: 'ES',
      code: 'LLE',
      wspCity: 'CITY__LLE',
      name: 'LLeida',
      alias: 'Lleida',
      lat: '41.6178718',
      lon: '0.6189043',
      web: 'https://lleida.wesmartpark.com',
      defaultLanguage: {
        lang: 'ca',
        langWsp: 'ca_ES',
        langIso: 'ca-ES',
        name: 'Català',
      },
      zoom: 14,
      googleAnalyticsAppId: '1:202996681746:web:3685b4e66bc46d0cb2dccb',
      googleAnalyticsMeasurementId: 'G-4G53F5C5DQ',
    },
    SCL: {
      country: 'CL',
      code: 'SCL',
      wspCity: 'CITY__SCL',
      name: 'Santiago de Chile',
      alias: 'Santiago',
      lat: '-33.425000',
      lon: '-70.630000',
      web: 'https://santiago.wesmartpark.com',
      defaultLanguage: {
        lang: 'es',
        langWsp: 'es_CL',
        langIso: 'es-CL',
        name: 'Español',
      },
      zoom: 13,
      googleAnalyticsAppId: '1:202996681746:web:30e501f482ba2b34b2dccb',
      googleAnalyticsMeasurementId: 'G-PXNNWZE2Y8',
    },
  },
  COUNTRIES: {
    CL: {
      code: 'CL',
      prefix: '+56',
      isoAlpha3: 'CHL',
      name: 'Chile',
      twitterHastag: '@wesmartPark_CL',
      languages: [
        {
          lang: 'es',
          langWsp: 'es_CL',
          langIso: 'es-CL',
          name: 'Español',
        },
        {
          lang: 'en',
          langWsp: 'en_GB',
          langIso: 'en-GB',
          name: 'English',
        },
      ],

      cities: [
        {
          code: 'SCL',
          name: 'Santiago de Chile',
          alias: 'Santiago',
          lat: '-33.444200',
          lon: '-70.653215',
          web: 'https://santiago.wesmartpark.com',
        },
      ],

      currency: {
        code: '$',
        order: 'before',
        decimals: 0,
        decimalsDetailed: 0,
        iso: 'CLP'
      },

      parking: {
        showComingSoon: true,
      },

      hasBle: true,
      timeZone: 'America/Santiago',

      prices: {
        hour: '1.200',
        minute: '20',
        register: '3.000',
        godfather: '2.000',
        godfatherRegister: '1.000',
        godfatherTotal: '3.000',
        teletag: '1.000',
        taxes: '19',
      },

      contact: {
        lat: '-33.4077551',
        lon: '-70.566541',
        schedule: '8:00-17:00',
        phone: '9 3186 0329',
        phoneEmergency: '9 3186 0329',
        prefix: '+56',
        email: 'info.chile@wesmartpark.com',
      },

      subscription: {
        night: '6.000',
        '24h': '9.000',
        week: '26.000',
        month: '60.000'
      },

      legal: {
        useTerms:
          'https://9sp-public.s3.eu-west-1.amazonaws.com/legal/chile/wsp_terms_of_use.pdf',
        privacy:
          'https://9sp-public.s3.eu-west-1.amazonaws.com/legal/chile/wsp_terms_of_use.pdf'
      },

      api: 'https://api-chile.wesmartpark.com',
      googleKey: 'AIzaSyDlpViOkBZ8UOuLyX2FmU1rf-RcXxhFHqc',
    },
    ES: {
      code: 'ES',
      prefix: '+34',
      isoAlpha3: 'ESP',
      name: 'España',
      twitterHastag: '@wesmartPark',
      languages: [
        {
          lang: 'es',
          langWsp: 'es_ES',
          langIso: 'es-ES',
          name: 'Castellano',
        },
        {
          lang: 'en',
          langWsp: 'en_GB',
          langIso: 'en-GB',
          name: 'English',
        },
        {
          lang: 'ca',
          langWsp: 'ca_ES',
          langIso: 'ca-ES',
          name: 'Català',
        },
      ],

      cities: [
        {
          code: 'MAD',
          name: 'Madrid',
          alias: 'Madrid',
          lat: '40.441000',
          lon: '-3.686890',
          web: 'https://madrid.wesmartpark.com',
        },
        {
          code: 'BCN',
          name: 'Barcelona',
          alias: 'Barcelona',
          lat: '41.39479',
          lon: '2.1587679',
          web: 'https://barcelona.wesmartpark.com',
        },
        {
          code: 'LLE',
          name: 'LLeida',
          alias: 'Lleida',
          lat: '41.6178718',
          lon: '0.6189043',
          web: 'https://lleida.wesmartpark.com',
        },
      ],

      currency: {
        code: '€',
        order: 'after',
        decimals: 2,
        decimalsDetailed: 4,
        iso: 'EUR'
      },

      parking: {
        showComingSoon: false,
      },

      hasBle: true,

      timeZone: 'Europe/Madrid',

      prices: {
        hour: '1,95',
        minute: '0.0325',
        register: '3',
        godfather: '5',
        teletag: '1',
        taxes: '21',
      },

      contact: {
        lat: '-70.00000',
        lon: '-33.00000',
        schedule: '9:00-17:00',
        phone: '93 224 60 23',
        phoneEmergency: '902 676 836',
        prefix: '+34',
        email: 'info@wesmartpark.com',
      },

      subscription: {
        night: '8',
        '24h': '12',
        week: '35',
        month: '80'
      },

      legal: {
        useTerms:
          'https://9sp-public.s3-eu-west-1.amazonaws.com/legal/spain/wsp_terms_of_use.pdf',
        privacy:
          'https://s3-eu-west-1.amazonaws.com/9sp-public/privacy_policy.pdf',
      },

      api: 'https://api.wesmartpark.com',
      googleKey: 'AIzaSyD-__TJwDBePP9ckSe6dteEV598zj98hRg',
    },
  },
  LANGUAGES: {
    'es-ES': {
      lang: 'es',
      langWsp: 'es_ES',
      langIso: 'es-ES',
      langName: 'Castellano',
      country: 'España',
      appleBadge: 'es-ES',
    },
    'ca-ES': {
      lang: 'ca',
      langWsp: 'ca_ES',
      langIso: 'ca-ES',
      langName: 'Català',
      country: 'España',
      appleBadge: 'es-ES',
    },
    'es-CL': {
      lang: 'es',
      langWsp: 'es_CL',
      langIso: 'es-CL',
      langName: 'Español',
      country: 'Chile',
      appleBadge: 'es-CL',
    },
    'en-GB': {
      lang: 'en',
      langWsp: 'en_GB',
      langIso: 'en-GB',
      langName: 'English',
      country: 'Global',
      appleBadge: 'en-GB',
    },
  },
  HEADQUARTERS: [
    {
      city: 'Barcelona',
      address1: 'Gran Vía de les Corts Catalanes 917',
      address2: '08018 Barcelona, Spain',
      addressLink:
        'https://www.google.com/maps/place/Gran+Via+de+les+Corts+Catalanes,+917,+08018+Barcelona/@41.40942,2.193988,17z',
      phone: '93 224 60 23',
      phoneDescription: 'Días laborales de 9 a 17h',
      phoneEmergency: '902 676 836',
      phoneEmergencyDescription: 'Fuera del horario laboral',
      email: 'info@wesmartpark.com',
    },
    {
      city: 'Madrid',
      address1: 'Gran Vía de les Corts Catalanes 917',
      address2: '08018 Barcelona, Spain',
      addressLink:
        'https://www.google.com/maps/place/Gran+Via+de+les+Corts+Catalanes,+917,+08018+Barcelona/@41.40942,2.193988,17z',
      phone: '93 224 60 23',
      phoneDescription: 'Días laborales de 9 a 17h',
      phoneEmergency: '902 676 836',
      phoneEmergencyDescription: 'Fuera del horario laboral',
      email: 'info@wesmartpark.com',
    },
    {
      city: 'Lleida',
      address1: 'Gran Vía de les Corts Catalanes 917',
      address2: '08018 Barcelona, Spain',
      addressLink:
        'https://www.google.com/maps/place/Gran+Via+de+les+Corts+Catalanes,+917,+08018+Barcelona/@41.40942,2.193988,17z',
      phone: '93 224 60 23',
      phoneDescription: 'Días laborales de 9 a 17h',
      phoneEmergency: '902 676 836',
      phoneEmergencyDescription: 'Fuera del horario laboral',
      email: 'info@wesmartpark.com',
    },
    {
      city: 'Santiago',
      address1: 'Av. Apoquindo 6410, oficina 605',
      address2: 'Las Condes - Santiago',
      addressLink:
        'https://www.google.com/maps/place/Av.+Apoquindo+6410,+dpto+605,+Las+Condes,+Regi%C3%B3n+Metropolitana,+Chile/@-33.4077551,-70.566541,17z',
      phone: '+56 9 3186 0329',
      phoneDescription: 'Lunes a jueves: 8:30 a 13:30 - 14:30 a 18:30<br/>Viernes: 8:30 a 13:30 - 14:30 a 16:30',
      phoneEmergency: '+56 9 3186 0329',
      phoneEmergencyDescription: 'Fuera del horario laboral',
      email: 'info.chile@wesmartpark.com',
    },
    {
      city: 'New York',
      address1: '20 Jay St Suite 312',
      address2: 'Brooklyn, NY, 11201',
      addressLink:
        'https://www.google.com/maps/place/20+Jay+St+%23312,+Brooklyn,+NY+11201,+USA/@40.704035,-73.986724,15z',
      phone: '(+1) 646 280 0882',
      phoneDescription: 'Días laborales de 9 a 17h',
      phoneEmergency: '902 676 836',
      phoneEmergencyDescription: '',
      email: 'info@wesmartpark.com',
    },
  ],
  SPANISH_COUNTRIES: [
    'AR',
    'BO',
    'CL',
    'CO',
    'CR',
    'CU',
    'EC',
    'SV',
    'ES',
    'GT',
    'GQ',
    'HN',
    'MX',
    'NI',
    'PA',
    'PY',
    'PE',
    'DO',
    'UY',
    'VE',
  ],
  SITE: {
    ES: {
      MEDIA: [
        {
          image: 'forbes',
          link: 'https://www.forbes.com/sites/federicoguerrini/2014/05/06/the-pros-and-cons-of-smart-cities/#4e7c0e1a69be',
          name: 'Forbes',
        },
        {
          image: 'nytimes',
          link: 'https://www.nytimes.com/2014/04/22/business/energy-environment/europe-remains-ahead-of-us-in-creating-smart-cities.html?_r=0',
          name: 'The New York Times',
        },
        {
          image: 'europa-press',
          link: 'https://www.europapress.es/catalunya/barcelona-economias-00982/noticia-4yfn-premia-app-wesmartpark-solucion-movilidad-ciudades-inteligentes-20161117183506.html',
          name: 'Europapress',
        },
      ],
      VIDEO: 'https://www.youtube.com/embed/bw2WVS_NShM',
      TYPEFORM: 'https://wsp1.typeform.com/to/ujBj2t?origin=site',
      USERS: [
        {
          name: 'Marc',
          message:
            'La mejor app para aparcar, cero problemas y además cuesta la mitad que un parking convencional',
        },
        {
          name: 'Victoria',
          message:
            'Imprescindible, una pasada. Tiene buenos parkings, bien localizados y muchos de ellos son 24 horas',
        },
        {
          name: 'Sergio',
          message:
            'La uso casi a diario y es comodísima, se hace todo desde la app, reservar con antelación, las puertas se abren automáticas, las facturas te llegan a la app directamente... una gozada',
        },
      ],
      SOCIAL: {
        FACEBOOK: 'https://www.facebook.com/wesmartpark',
        YOUTUBE: 'https://www.youtube.com/user/WeSmartPark',
        TWITTER: 'https://twitter.com/wesmartPark',
        LINKEDIN: 'https://www.linkedin.com/company/9smart/',
        INSTAGRAM: 'https://www.instagram.com/wesmartpark/',
      },
      APP: {
        ANDROID:
          'https://play.google.com/store/apps/details?id=com.wesmartpark.parking',
        APPLE:
          'https://itunes.apple.com/es/app/wesmartpark-aparcar-barato/id573568924',
      },
      MKT: {
        BCN: {
          USERS: '235.000',
          PARKINGS: '150',
        },
        MAD: {
          USERS: '235.000',
          PARKINGS: '150',
        },
        LLE: {
          USERS: '235.000',
          PARKINGS: '150',
        },
      },
    },
    CL: {
      MEDIA: [
        {
          image: 'emol',
          link: 'https://www.emol.com/noticias/Economia/2018/04/07/901574/Estacionamientos-muy-caros-Aplicacion-busca-reducir-costos-para-automovilistas-en-sectores-con-mayor-demanda-en-Santiago.html',
          name: 'Emol',
        },
        {
          image: 'cnn',
          link: 'https://www.cnnchile.com/tendencias/nueva-app-wesmartpark-ofrece-estacionamientos-mas-baratos_20180309/',
          name: 'CNN',
        },
        {
          image: 'chile-vision',
          link: 'https://www.chvnoticias.cl/trending/wesmartpark-la-aplicacion-que-recomienda-estacionamientos_20180309/',
          name: 'Chilevision',
        },
      ],
      VIDEO: 'https://www.youtube.com/embed/NnhKocYMGdk',
      TYPEFORM: 'https://wsp1.typeform.com/to/ujBj2t?origin=site',
      USERS: [
        {
          name: 'Andrea',
          message:
            'La aplicación es genial, me permite coordinar mi llegada a las reuniones, salir y entrar rápidamente del parking, sin trámites... además pago menos!!',
        },
        {
          name: 'Armando',
          message:
            'Una solución integral al problema de los estacionamientos en Santiago. Sin duda el precio y lo fácil de la aplicación hacen la diferencia',
        },
        {
          name: 'José Ignacio',
          message:
            'Es un agrado saber que vas a tener reservado un lugar donde estacionar y cerca de donde quieres ir. Es cómodo, rápido, bien señalizado y además a mitad de precio',
        },
      ],
      SOCIAL: {
        FACEBOOK: 'http://bit.ly/facebook_wsp',
        YOUTUBE: 'https://www.youtube.com/user/WeSmartPark',
        TWITTER: 'https://twitter.com/wesmartPark_CL',
        LINKEDIN: 'https://www.linkedin.com/company/9smart/',
        INSTAGRAM: 'https://www.instagram.com/wesmartpark_chile/',
      },
      APP: {
        ANDROID:
          'https://play.google.com/store/apps/details?id=com.wesmartpark.parking',
        APPLE:
          'https://itunes.apple.com/es/app/wesmartpark-aparcar-barato/id573568924',
      },
      MKT: {
        SCL: {
          USERS: '75.000',
          PARKINGS: '55',
        },
      },
    },
  },
};

export { config };
